<template>
  <div
    id="privilege-information-expriration-mode"
    class="form-custom"
  >
    <b-row class="expriration-mode-form">
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-2"
        >
          <b-card-header>
            <span class="information-header">Expiration Mode</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col col-md-6">
                  <div class="mb-2 mt-2">
                    <div class="mb-2">
                      <label
                        for="exp_mode"
                        class="font-medium-5"
                      >Expiration Mode</label>
                      <v-select
                        id="exp_mode"
                        v-model="formData.ExpirationMode"
                        class="expriration-mode-container bg-dropdown"
                        :class="
                          formData.ExpirationMode
                            ? 'expriration-mode-selected'
                            : null
                        "
                        placeholder="--Select--"
                        :reduce="option => option.value"
                        :options="formData.privilegeType == 5 ? PrivilegeExpirationMode.filter(o => o.value != 4) : PrivilegeExpirationMode"
                        :clearable="false"
                      />
                    </div>

                    <div
                      v-if="
                        formData.ExpirationMode !== 1 &&
                          formData.ExpirationMode !== 4
                      "
                      class="mt-2 mb-2"
                    >
                      <label
                        for="exp_rounding_mode"
                        class="font-medium-5"
                      >Expiration Rounding Mode</label>
                      <v-select
                        id="exp_rounding_mode"
                        v-model="formData.ExpRoundingMode"
                        class="expriration-mode-container bg-dropdown"
                        :class="
                          formData.ExpRoundingMode
                            ? 'expriration-mode-selected'
                            : null
                        "
                        placeholder="--Select--"
                        :reduce="option => option.value"
                        :options="PrivilegeExpRoundingMode"
                        :clearable="false"
                      />
                    </div>

                    <!-- hide and show -->
                    <div
                      v-if="formData.ExpirationMode == 2"
                      class="mt-2"
                    >
                      <div class="row">
                        <div class="col col-md-6">
                          <b-form-group
                            :label="'Exp. Period - Year'"
                            label-for="'exp-year"
                            class=""
                          >
                            <b-form-input
                              id="exp-year"
                              v-model="formData.ExpYear"
                              @input="$emit('onNumberInput', $event, 'ExpYear')"
                            />
                          </b-form-group>
                        </div>
                        <div class="col col-md-6">
                          <b-form-group
                            :label="'Exp. Period - Month'"
                            label-for="'exp-month"
                            class=""
                          >
                            <b-form-input
                              id="exp-month"
                              v-model="formData.ExpMonth"
                              @input="
                                $emit('onNumberInput', $event, 'ExpMonth')
                              "
                            />
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col col-md-6">
                          <b-form-group
                            :label="'Exp. Period - Day'"
                            label-for="'exp-day"
                            class=""
                          >
                            <b-form-input
                              id="exp-day"
                              v-model="formData.ExpDay"
                              @input="$emit('onNumberInput', $event, 'ExpDay')"
                            />
                          </b-form-group>
                        </div>
                        <div class="col col-md-6">
                          <b-form-group
                            :label="'Exp. Period - Hour'"
                            label-for="'exp-hour"
                            class=""
                          >
                            <b-form-input
                              id="exp-hour"
                              v-model="formData.ExpHour"
                              @input="$emit('onNumberInput', $event, 'ExpHour')"
                            />
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col col-md-6">
                          <b-form-group
                            :label="'Exp. Period - Minute'"
                            label-for="'exp--minute"
                            class=""
                          >
                            <b-form-input
                              id="exp--minute"
                              v-model="formData.ExpMinute"
                              @input="
                                $emit('onNumberInput', $event, 'ExpMinute')
                              "
                            />
                          </b-form-group>
                        </div>
                        <div class="col col-md-6" />
                      </div>
                    </div>

                    <div
                      v-else-if="formData.ExpirationMode == 3"
                      class="mt-2"
                    >
                      <div class="row">
                        <div class="col-12 col-md-12">
                          <div>
                            <label
                              for="valid-from-date"
                              class=""
                            >
                              Exp. Fixed Date
                            </label>
                            <div class="d-flex">
                              <div
                                class="
                                    col
                                    p-0 p-relative
                                    mr-2
                                    expiration-mode-date-picker
                                  "
                              >
                                <calendar-picker-icon
                                  class="icon-calendar bypass"
                                  :class="
                                    formData.fixedDate.date
                                      ? 'date-selected-icon'
                                      : null
                                  "
                                />
                                <flat-pickr
                                  :id="'valid-from-date'"
                                  v-model="formData.fixedDate.date"
                                  class="form-control  bg-date"
                                  :class="
                                    formData.fixedDate.date
                                      ? 'date-selected'
                                      : null
                                  "
                                  :config="flatpickrDateConfig"
                                  placeholder="Start Date"
                                  autocomplete="off"
                                  @on-open="onOpenValidFromDatePicker"
                                  @on-change="onSelectFixedDate"
                                />
                              </div>
                              <div
                                class="
                                    col
                                    p-0 p-relative
                                    expiration-mode-date-picker
                                  "
                              >
                                <clock-picker-icon
                                  class="icon-calendar date-picker-icon bypass"
                                  :class="
                                    formData.fixedDate.time
                                      ? 'date-selected-icon'
                                      : null
                                  "
                                />
                                <flat-pickr
                                  id="valid-from-time"
                                  v-model="formData.fixedDate.time"
                                  class="form-control  bg-date"
                                  :class="
                                    formData.fixedDate.time
                                      ? 'date-selected'
                                      : null
                                  "
                                  :config="flatpickrTimeConfig"
                                  :placeholder="'HH : mm'"
                                  autocomplete="off"
                                  @on-open="onOpenValidFromTimePicker"
                                  @on-change="onSelectFixedDateTime"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import CalendarPickerIcon from '@/@core/components/svg/common/CalendarPicker.vue'
import ClockPickerIcon from '@/@core/components/svg/common/ClockPicker.vue'
import flatPickr from 'vue-flatpickr-component'
import usePrivilegeInformation from '../../hooks/usePrivilegeInformation'

export default {
  components: {
    vSelect,
    CalendarPickerIcon,
    ClockPickerIcon,
    flatPickr,
  },
  props: { formData: { type: Object, default: {} } },

  setup(props) {
    const {
      PrivilegeExpirationMode,
      PrivilegeExpRoundingMode,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectFixedDate,
      onSelectFixedDateTime,
    } = usePrivilegeInformation(props)
    return {
      PrivilegeExpirationMode,
      PrivilegeExpRoundingMode,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectFixedDate,
      onSelectFixedDateTime,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/privilege/privilege-information-expiration-mode.css';
</style>
